import { LoginForm } from "./LoginForm";

export function LoginPage() {
  return (
    <div className="mx-auto max-w-md">
      <LoginForm />
    </div>
  );
}
